// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"2240e005","140":"5771066c","239":"1f27f552","372":"1486f748","426":"108eac81","453":"8fec9fba","455":"9b539ea9","482":"91b04803","715":"97822aa7","724":"3a76ee7f","787":"55b1a5f5","914":"88929b96","977":"7af302e0"}[chunkId] + ".chunk.js";
};